module.exports = __webpack_public_path__ + "static/media/_MIC2334.thumbnail.badd00de.png";